module.exports = global["$"] = require("-!/var/www/html/node_modules/expose-loader/index.js?jQuery!/var/www/html/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 18
// module chunks = 0